import { render } from "./Home.vue?vue&type=template&id=bd61081a&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=bd61081a&scoped=true&lang=css"

import exportComponent from "/Users/dlhaibin/WebVue/zhimoxiezuo_web官网/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bd61081a"]])

export default __exports__